(function($) {

	hljs.initHighlightingOnLoad();

})(jQuery);